import { render, staticRenderFns } from "./StallShopInfo.vue?vue&type=template&id=d2ac0bda&scoped=true"
import script from "./StallShopInfo.vue?vue&type=script&lang=js"
export * from "./StallShopInfo.vue?vue&type=script&lang=js"
import style0 from "./StallShopInfo.vue?vue&type=style&index=0&id=d2ac0bda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2ac0bda",
  null
  
)

export default component.exports